export default __webpack_public_path__ + "static/media/shape-open.ca51cf95.svg";